import script from "./dashboard-nav-theme-toggle.vue?vue&type=script&lang=ts&setup=true"
export * from "./dashboard-nav-theme-toggle.vue?vue&type=script&lang=ts&setup=true"

import "./dashboard-nav-theme-toggle.vue?vue&type=style&index=0&id=4f1b0238&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f1b0238"]])

export default __exports__